import { render, staticRenderFns } from "./passGroupForm.vue?vue&type=template&id=707b7c2c&scoped=true"
import script from "./passGroupForm.vue?vue&type=script&lang=js"
export * from "./passGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b7c2c",
  null
  
)

export default component.exports